<template>
  <div class="chat-skeleton-container">
    <div
      v-for="i in 5"
      :key="`skeleton-${i}`"
      class="chat-skeleton-item d-flex align-start"
      :class="[
        i % 2 === 0 ? 'flex-row-reverse' : '',
        i % 2 === 0
          ? 'chat-skeleton-item--mine'
          : 'chat-skeleton-item--theirs',
      ]"
    >
      <div
        class="chat-skeleton-avatar"
        :class="i % 2 === 0 ? 'ms-4' : 'me-4'"
      >
        <VSkeletonLoader
          type="image"
          width="32"
          height="32"
          class="chat-skeleton-avatar-loader"
        />
      </div>

      <div
        class="chat-skeleton-message d-flex flex-column"
        :class="[
          i % 2 === 0 ? 'align-end' : 'align-start',
          i % 2 === 0
            ? 'chat-skeleton-message--mine'
            : 'chat-skeleton-message--theirs',
        ]"
      >
        <div
          class="chat-skeleton-bars d-flex flex-column"
          :class="
            i % 2 === 0
              ? 'chat-skeleton-bars--mine'
              : 'chat-skeleton-bars--theirs'
          "
        >
          <VSkeletonLoader
            v-if="i === 1 || i === 3"
            type="text"
            width="250"
            class="chat-skeleton-text"
          />
          <VSkeletonLoader
            v-else-if="i === 2"
            type="text"
            width="180"
            class="chat-skeleton-text"
          />
          <VSkeletonLoader
            v-else
            type="text"
            width="200"
            class="chat-skeleton-text"
          />

          <VSkeletonLoader
            v-if="i === 1 || i === 4"
            type="text"
            width="150"
            class="chat-skeleton-text"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" src="@/modules/chat-matrix-fast/styles/chat-log.scss"></style>
